import { z } from 'zod';

export const SCreateBookServiceSlotRequest = z.object({
  full_name: z.string(),
  nik: z.string(),
  phone_number: z.string(),
  gender: z.number(),
  birth_date: z.string(),
  job: z.number(),
  address: z.string(),
  payment_type: z.number(),
  treatment_place: z.number(),
  has_previous_treatment: z.boolean(),
  discovery_method: z.array(z.number()),
  ss_id: z.number(),
  method: z.string().nullable(),
});
export type TCreateBookServiceSlotRequest = z.infer<
  typeof SCreateBookServiceSlotRequest
>;
